import type { AddressStep } from '~/types/registration'

import type { UserType } from '#shared/types/users.ts'

export function pushEventToDataLayer(event: string) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: event
  })
}

export function setIsKookmeer() {
  const registrationStore = useRegistrationStore()
  registrationStore.setIsKookmeer()
}

export function setIsPraatjePot() {
  const registrationStore = useRegistrationStore()
  registrationStore.setIsPraatjePot()
}

export function setIsVoorproefje() {
  const registrationStore = useRegistrationStore()
  // Temporarily changed to false
  registrationStore.setIsVoorproefje(false)
}

export function hasFoundUserAddress(userType: UserType, address: AddressStep) {
  const registrationStore = useRegistrationStore()

  const addressSearchResultPostalCode = removeWhitespaceFromString(
    registrationStore[userType].addressSearchResult?.postalCode
  )?.toLowerCase()
  const addressSearchResultHouseNumber = removeWhitespaceFromString(
    registrationStore[userType].addressSearchResult?.houseNumber
  )

  const postalCodeField = removeWhitespaceFromString(address.postalCode)?.toLowerCase()
  const houseNumberField = removeWhitespaceFromString(address.houseNumber)

  return (
    postalCodeField === addressSearchResultPostalCode &&
    houseNumberField === addressSearchResultHouseNumber
  )
}
